import { Component, type ReactNode } from 'react';
import Alert from '@mui/material/Alert';

export interface BlockErrorBoundaryProps {
  children: ReactNode;
  /** Human-readable name of the construct, used in the fallback message. */
  label: string;
}

interface State {
  failed: boolean;
}

/**
 * Per-block boundary.
 *
 * Wrapping individual constructs is what keeps one bad diagram, formula or code
 * fence from taking down the surrounding document.
 */
export class BlockErrorBoundary extends Component<BlockErrorBoundaryProps, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error): void {
    console.warn(`Failed to render ${this.props.label}.`, error);
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children;

    return (
      <Alert severity="warning" variant="outlined" sx={{ my: 2 }}>
        {`This ${this.props.label} could not be rendered.`}
      </Alert>
    );
  }
}

export default BlockErrorBoundary;
